import { render, staticRenderFns } from "./SharingLinkList.vue?vue&type=template&id=537e15c5&"
import script from "./SharingLinkList.vue?vue&type=script&lang=js&"
export * from "./SharingLinkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports